// extracted by mini-css-extract-plugin
export default {"confirm":"style_confirm__CRUl0","desc":"style_desc__nOaKl","btn-del":"style_btn-del__QJn0w"};